// src-mlr/app.config.js

"use strict";
appConfig.$inject = ['$ocLazyLoadProvider', "$compileProvider", "$sceDelegateProvider"];

export default function appConfig($ocLazyLoadProvider, $compileProvider, $sceDelegateProvider)
{
  $compileProvider.debugInfoEnabled(process.env.NODE_ENV == 'development' ? false : true);
  $ocLazyLoadProvider.config({
    debug: process.env.NODE_ENV == 'development' ? true : false,
    events: process.env.NODE_ENV == 'development' ? true : false,
    modules: [
      {
        name: 'vimeo',
        files: ['https://player.vimeo.com/api/player.js']
      },
      {
        name: 'wistia',
        files: ['https://fast.wistia.com/assets/external/E-v1.js']
      },
      {
        name: 'beacon',
        files: ['https://media.mirasee.com/js/chat/beacon.js']
      },
    ]
  });
  $sceDelegateProvider.resourceUrlWhitelist([
    // Allow same origin resource loads.
    'self',
    // Allow loading from our assets domain. **.
    'http://localhost:8086/**',
  ]);
  // $httpProvider.defaults.headers.common.Authorization = 'Bearer ' + token;
}
